
import Model from '../utils/Model'

class LineOfBusiness {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'LineOfBusiness'

export const NULL_TYPE = new LineOfBusiness('', '', '')
export const SE_TYPE = new LineOfBusiness('SE', 'Sea Export', '海运出口')
export const SI_TYPE = new LineOfBusiness('SI', 'Sea Import', '海运进口')
export const AE_TYPE = new LineOfBusiness('AE', 'Air Export', '空运出口')
export const AI_TYPE = new LineOfBusiness('AI', 'Air Import', '空运进口')
export const SIE_TYPE = new LineOfBusiness('SIE', 'Sea Import & Export', '海运进出')
export const AIE_TYPE = new LineOfBusiness('AIE', 'Air Import & Export', '空运进出')
export const ALL_TYPE = new LineOfBusiness('ALL', 'All', '全部')
export const LOB_TYPE_COUNT = 5

export const LOBS = [ALL_TYPE, SE_TYPE, SI_TYPE, AE_TYPE, AI_TYPE]

/**
 *  return null:没找到.
 */
export function getLineOfBusinessByCode(code) {
  return Model.getObjByCode(code, LOBS)
}
